import { render, staticRenderFns } from "./MoreFilter.vue?vue&type=template&id=b864604a&"
import script from "./MoreFilter.vue?vue&type=script&lang=js&"
export * from "./MoreFilter.vue?vue&type=script&lang=js&"
import style0 from "./MoreFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports